import { GET_HISTORY } from './history.types';

export const getHistory = (params) => {
  return {
    type: GET_HISTORY,
    payload: { params },
  };
};
